module.exports = window["plaudit"]["queryLoop"];